import React, { Component } from 'react'
import $ from 'jquery';
import axios from 'axios';
import ReactPaginate from 'react-paginate';
import { Link } from 'react-router-dom';
import Cookies from 'universal-cookie';
import { NavbarLog } from '../../navbar/NavbarLog';
import { Table, Button, Container, Modal, ModalHeader, ModalBody, ModalFooter, FormGroup, ListGroupItemText } from 'reactstrap';
import { ApiUrl } from '../../services/ApiRest';
import swal from 'sweetalert';

const cookie = new Cookies();
const api_key = "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71"
const UrlListarParalelos = ApiUrl + "paralelos?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const UrlListarCreditos = ApiUrl + "creditos-extra?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const UrlListarDocentes = ApiUrl + "listusuariosadmdocen" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const UrlListarPeriodos = ApiUrl + "listarperiodosactivos" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const UrlListarAsignaciones = ApiUrl + "docente-creditosext-periodo" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const UrlInsertarAsignacion = ApiUrl + "docente-creditos-extra" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const UrlActualizarAsignacion = ApiUrl + "docente-creditos-extra";
const urlListarEstudiantesCreditos = ApiUrl + "estudiantes-creditosext-periodo" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";

export default class GestionDocenteCreditosExtra extends Component {
  state = {
    docentes: [],
    docentesFiltrados: [],
    currentItems: [],
    offset: 0,
    perPage: 5,
    pageCount: 0,
    busqueda: "",
    docenteSeleccionado: null,
    periodoSeleccionado: "",
    periodos: [],
    asignaciones: [],
    creditos: [],
    paralelos: [],
    modal: false,
    modalListado: false,
    loadingLista: false,
    asignaturaActual: "",
    periodoActual: "",
    paraleloActual: "",
    estudiantesCredito: [],
    form: {
      id: "",
      administrativo_id: "",
      credito_extra_id: "",
      periodo_academico_id: "",
      paralelo_id: "",
      fecha_inicio: "",
      fecha_fin: "",
      detalle: ""
    },
  };

  componentDidMount() {
    this.obtenerDocentes();
    this.obtenerPeriodos();
    this.obtenerCreditos();
    this.obtenerParalelos();
  }

  obtenerDocentes = () => {
    axios.get(UrlListarDocentes).then(res => {
      const docentes = res?.data?.data ?? [];
      const currentItems = docentes.slice(0, this.state.perPage);

      this.setState({
        docentes,
        docentesFiltrados: docentes, // copia para buscar
        pageCount: Math.ceil(docentes.length / this.state.perPage),
        currentItems,
        offset: 0
      });
    });
  };

  filtrarDocentes = (e) => {
    const texto = (e.target.value || "").toLowerCase();

    const docentesFiltrados = this.state.docentes.filter(d =>
      (d.numero_identificacion_administrativo || "").toLowerCase().includes(texto) ||
      (d.nombres_administrativo || "").toLowerCase().includes(texto) ||
      (d.apellidos_administrativo || "").toLowerCase().includes(texto) ||
      (d.email_administrativo || "").toLowerCase().includes(texto)
    );

    const currentItems = docentesFiltrados.slice(0, this.state.perPage);

    this.setState({
      busqueda: texto,
      docentesFiltrados,
      currentItems,
      pageCount: Math.ceil(docentesFiltrados.length / this.state.perPage),
      offset: 0
    });
  };

  handlePageClick = (e) => {
    const selectedPage = e.selected;
    const offset = selectedPage * this.state.perPage;
    const slice = this.state.docentesFiltrados.slice(offset, offset + this.state.perPage);
    this.setState({ currentItems: slice, offset });
  };

  obtenerPeriodos = () => {
    axios.get(UrlListarPeriodos).then(res => {
      this.setState({ periodos: res.data.data || [] });
    });
  };

  obtenerCreditos = () => {
    axios.get(UrlListarCreditos).then(res => {
      this.setState({ creditos: res.data || [] });
    });
  };

  obtenerParalelos = () => {
    axios.get(UrlListarParalelos).then(res => {
      this.setState({ paralelos: res.data || [] });
    });
  };

  seleccionarDocente = (id) => {
    this.setState({ docenteSeleccionado: id, asignaciones: [] });
  };

  seleccionarPeriodo = (e) => {
    const periodoSeleccionado = Number(e.target.value);
    this.setState({ periodoSeleccionado }, () => {
      if (this.state.docenteSeleccionado) {
        this.obtenerAsignaciones();
      }
    });
  };

  obtenerAsignaciones = () => {
    const { docenteSeleccionado, periodoSeleccionado } = this.state;
    axios.get(`${UrlListarAsignaciones}&administrativo_id=${docenteSeleccionado}&periodo_academico_id=${periodoSeleccionado}`).then(res => {
      this.setState({ asignaciones: res.data });
    });
  };

  mostrarModal = (asignacion = null) => {
    if (asignacion) {
      this.setState({ modal: true, form: { ...asignacion } });
    } else {
      this.setState({
        modal: true,
        form: {
          id: "",
          administrativo_id: this.state.docenteSeleccionado,
          credito_extra_id: "",
          periodo_academico_id: this.state.periodoSeleccionado,
          paralelo_id: "",
          fecha_inicio: "",
          fecha_fin: "",
          detalle: ""
        }
      });
    }
  };

  ocultarModal = () => {
    this.setState({ modal: false });
  };

  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState({ form: { ...this.state.form, [name]: value } });
  };

  guardarAsignacion = () => {
    const { form } = this.state;

    // Convertir a número los campos que deben ser numéricos
    const formData = {
      ...form,
      administrativo_id: Number(form.administrativo_id),
      credito_extra_id: Number(form.credito_extra_id),
      periodo_academico_id: Number(form.periodo_academico_id),
      paralelo_id: Number(form.paralelo_id),
    };

    const peticion = form.id
      ? axios.put(`${UrlActualizarAsignacion}/${form.id}${api_key}`, formData)
      : axios.post(UrlInsertarAsignacion, formData);

    peticion.then(() => {
      this.ocultarModal();
      this.obtenerAsignaciones();
    });
  };

  listarEstudiantesCredito = (id_credito_extra, id_paralelo) => {
    this.setState({ loadingLista: true });

    axios
      .get(`${urlListarEstudiantesCreditos}&idCreditoExtra=${id_credito_extra}&idParalelo=${id_paralelo}&idPeriodo=${this.state.periodoSeleccionado}`)
      .then(response => {
        const lista = response.data || [];

        // Título del modal: nombre de la asignatura y periodo
        const asignatura = lista[0]?.credito_extra?.descripcion || "Crédito extra";
        const periodo = (this.state.periodos || []).find(
          p => String(p.id_periodo_academico) === String(this.state.periodoSeleccionado)
        );
        const periodoDesc = periodo?.descripcion_periodo_academico || "";
        const paraleloDesc =
          lista[0]?.paralelo?.nombre_paralelo
          ?? lista[0]?.paralelo?.descripcion_paralelo
          ?? (this.state.paralelos || []).find(
            p => String(p.id_paralelo) === String(id_paralelo)
          )?.nombre_paralelo
          ?? (this.state.paralelos || []).find(
            p => String(p.id_paralelo) === String(id_paralelo)
          )?.descripcion_paralelo
          ?? "";

        // (Opcional) si NO confías en el orden del backend, ordena por apellidos:
        const ordenados = [...lista].sort((a, b) => {
          const A = [
            a?.estudiante?.primer_apellido_estudiante,
            a?.estudiante?.segundo_apellido_estudiante,
            a?.estudiante?.primer_nombre_estudiante
          ].filter(Boolean).join(" ").toLowerCase();
          const B = [
            b?.estudiante?.primer_apellido_estudiante,
            b?.estudiante?.segundo_apellido_estudiante,
            b?.estudiante?.primer_nombre_estudiante
          ].filter(Boolean).join(" ").toLowerCase();
          return A.localeCompare(B);
        });

        this.setState({
          loadingLista: false,
          modalListado: true,
          asignaturaActual: asignatura,
          periodoActual: periodoDesc,
          paraleloActual: paraleloDesc,
          estudiantesCredito: ordenados
        });
      })
      .catch(() => this.setState({ loadingLista: false, modalListado: true, asignaturaActual: "", estudiantesCredito: [] }));
  };

  promedioparciales = (p1, p2, p3) => {
    var promp = (p1 + p2 + p3) / 3;
    var promp = (promp * 6) / 10;
    return (promp.toFixed(2))
  }

  promediosobre4 = (p10) => {
    var prom4 = (p10 * 4) / 10;
    return (prom4.toFixed(2))
  }

  promediototal = (p1, p2, p3, ef, es) => {
    var promp = (p1 + p2 + p3) / 3;
    var promp = (promp * 6) / 10;
    var examfinal = (ef * 4) / 10;
    var promacumulado = promp + examfinal;
    //var promfinal = promacumulado >= 7 ? promacumulado : (promacumulado + es) / 2;
    var promfinal = 0.00;
    if (promacumulado >= 7) {
      promfinal = promacumulado;
    }
    else {

      if (((promacumulado >= 4) && (promacumulado < 7)) && (es == 0)) {
        promfinal = promacumulado;
      }
      else {
        if (((promacumulado >= 4) && (promacumulado < 7)) && (es > 0)) {

          promfinal = (promacumulado + es) / 2;
        }
        else {
          promfinal = promacumulado;
        }
      }
    }
    return (promfinal.toFixed(2))
  }

  render() {
    return (
      <div className="row animate__animated animate__fadeIn">
        <div className="card shadow p-3 bg-white rounded">
          <div className="back-istmas">
            <b>Asignación de Créditos Extra a Docente</b>
          </div>
          <div className="p-3 rounded-3 mt-3">
            <h6 className="fw-bold text-center mb-3 text-azul">Listado de Docentes</h6>

            <input
              type="text"
              className="form-control form-control-sm mb-3"
              placeholder="Buscar por cédula, nombre o apellido"
              value={this.state.busqueda}
              onChange={this.filtrarDocentes}
            />

            <div className="table-responsive">
              <table className="table table-hover table-sm-custom">
                <thead className='text-azul'>
                  <tr>
                    <th>Cédula</th>
                    <th>Nombres</th>
                    <th>Apellidos</th>
                    <th>Celular</th>
                    <th>Convencional</th>
                    <th>Email</th>
                    <th>Dirección</th>
                    <th>Seleccionar</th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.currentItems.map(doc => (
                    <tr key={doc.id_administrativo}>
                      <td>{doc.numero_identificacion_administrativo}</td>
                      <td>{doc.nombres_administrativo}</td>
                      <td>{doc.apellidos_administrativo}</td>
                      <td>{doc.celular_administrativo}</td>
                      <td>{doc.convencional_administrativo}</td>
                      <td>{doc.email_administrativo}</td>
                      <td>{doc.direccion_administrativo}</td>
                      <td>
                        <input
                          type="radio"
                          name="docenteSeleccionado"
                          checked={this.state.docenteSeleccionado === doc.id_administrativo}
                          onChange={() => this.seleccionarDocente(doc.id_administrativo)}
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>

              <div className="d-flex justify-content-center mt-3">
                <ReactPaginate
                  previousLabel="<"
                  nextLabel=">"
                  pageCount={this.state.pageCount}
                  onPageChange={this.handlePageClick}
                  containerClassName="pagination pagination-sm-custom"
                  pageLinkClassName="page-link"
                  previousClassName="page-item"
                  previousLinkClassName="page-link"
                  nextClassName="page-item"
                  nextLinkClassName="page-link"
                  activeClassName="active"
                />
              </div>

              {this.state.docenteSeleccionado && (
                <div>
                  <h6 className="text-azul mt-4">Periodo Académico</h6>
                  <select className="form-select form-select-sm w-auto" onChange={this.seleccionarPeriodo}>
                    <option value="">Seleccione el período</option>
                    {this.state.periodos.map(p => (
                      <option key={p.id_periodo_academico} value={p.id_periodo_academico}>{p.descripcion_periodo_academico}</option>
                    ))}
                  </select>
                </div>
              )}
              {this.state.docenteSeleccionado && this.state.periodoSeleccionado && (
                <div>
                  <h6 className="text-azul mt-4">Créditos Extra Asignados</h6>
                  <table className="table table-hover table-sm-custom">
                    <thead className='text-azul'>
                      <tr>
                        <th>Crédito</th>
                        <th>Paralelo</th>
                        <th>Fecha Inicio</th>
                        <th>Fecha Fin</th>
                        <th>Detalle</th>
                        <th>Opciones</th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.asignaciones.map(a => (
                        <tr key={a.id}>
                          <td>{a.credito_extra?.descripcion || '-'}</td>
                          <td>{a.paralelo.nombre_paralelo}</td>
                          <td>{a.fecha_inicio || '-'}</td>
                          <td>{a.fecha_fin || '-'}</td>
                          <td>{a.detalle || '-'}</td>
                          <td>
                            <button className="btn btn-sm btn-primary" onClick={() => this.mostrarModal(a)}>
                              <i className="fa fa-edit"></i>
                            </button>
                            <button className="btn btn-sm btn-secondary" onClick={() => this.listarEstudiantesCredito(a.credito_extra_id, a.paralelo_id)}>
                              <i className="fa fa-user"></i>
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  <button className="btn btn-primary mt-3" onClick={() => this.mostrarModal()}>
                    Nueva Asignación
                  </button>
                </div>
              )}

              <Modal isOpen={this.state.modal}>
                <ModalHeader>Asignación de Crédito Extra</ModalHeader>
                <ModalBody>
                  <FormGroup>
                    <label>Crédito Extra</label>
                    <select className="form-select" id="credito_extra_id" name="credito_extra_id" value={this.state.form.credito_extra_id} onChange={this.handleChange} aria-label="Default select example">
                      <option value="undefined">Seleccione el crédito:</option>
                      {this.state.creditos.map(consola => <option key={consola.id} value={consola.id} > {consola.descripcion}</option>)}
                    </select>
                    <label className="form-label">Paralelo</label>
                    <select className="form-select" id="paralelo_id" name="paralelo_id" value={this.state.form.paralelo_id} onChange={this.handleChange} aria-label="Default select example">
                      <option value="undefined">Seleccione el paralelo:</option>
                      {this.state.paralelos.map(consola => <option key={consola.id_paralelo} value={consola.id_paralelo} > {consola.nombre_paralelo}</option>)}
                    </select>
                    <label>Fecha Inicio</label>
                    <input type="date" name="fecha_inicio" value={this.state.form.fecha_inicio} onChange={this.handleChange} className="form-control" />
                    <label>Fecha Fin</label>
                    <input type="date" name="fecha_fin" value={this.state.form.fecha_fin} onChange={this.handleChange} className="form-control" />
                    <label>Detalle</label>
                    <textarea name="detalle" value={this.state.form.detalle} onChange={this.handleChange} className="form-control"></textarea>
                  </FormGroup>
                </ModalBody>
                <ModalFooter>
                  <button className="btn btn-success" onClick={this.guardarAsignacion}>Guardar</button>
                  <button className="btn btn-danger" onClick={this.ocultarModal}>Cancelar</button>
                </ModalFooter>
              </Modal>

              <Modal isOpen={this.state.modalListado} toggle={() => this.setState({ modalListado: false })} size="lg" centered>
                <ModalHeader toggle={() => this.setState({ modalListado: false })}>
                  {this.state.asignaturaActual}
                  {this.state.periodoActual && (
                    <small className="d-block">
                      Período: {this.state.periodoActual}
                    </small>
                  )}
                  {this.state.paraleloActual && (
                    <small className="d-block">
                      Paralelo: {this.state.paraleloActual}
                    </small>
                  )}
                </ModalHeader>

                <ModalBody>
                  {this.state.loadingLista && (
                    <div className="alert alert-info py-2">Cargando listado…</div>
                  )}

                  {!this.state.loadingLista && this.state.estudiantesCredito.length === 0 && (
                    <div className="alert alert-warning">
                      El estudiante no tiene créditos extra asignados en el periodo seleccionado.
                    </div>
                  )}

                  {!this.state.loadingLista && this.state.estudiantesCredito.length > 0 && (
                    <div className="table-responsive">
                      <table className="table table-hover table-sm-custom">
                        <thead>
                          <tr className="text-azul">
                            <th>Estudiante</th>
                            <th>P1</th>
                            <th>P2</th>
                            <th>P3</th>
                            <th>Prom. Parcial/6</th>
                            <th>Final/4</th>
                            <th>Suspensión</th>
                            <th>Prom. Final/10</th>
                            <th>Estado</th>
                            <th>Asistencia</th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.estudiantesCredito.map((r) => {
                            const nombre = [
                              r?.estudiante?.primer_apellido_estudiante,
                              r?.estudiante?.segundo_apellido_estudiante,
                              r?.estudiante?.primer_nombre_estudiante,
                              r?.estudiante?.segundo_nombre_estudiante
                            ].filter(Boolean).join(" ");

                            const p1 = Number(r.parcial1) || 0;
                            const p2 = Number(r.parcial2) || 0;
                            const p3 = Number(r.parcial3) || 0;
                            const ef = Number(r.examen_final) || 0;
                            const es = Number(r.examen_suspension) || 0;

                            return (
                              <tr key={r.id} className="text-azul">
                                <td>{nombre || "—"}</td>
                                <td>{p1}</td>
                                <td>{p2}</td>
                                <td>{p3}</td>
                                <td>{this.promedioparciales(p1, p2, p3)}</td>
                                <td>{this.promediosobre4(ef)}</td>
                                <td>{es}</td>
                                <td>{this.promediototal(p1, p2, p3, ef, es)}</td>
                                <td>{r.equivalencia === 1 ? "Aprobado" : "Reprobado"}</td>
                                <td>{r.asistencia}</td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  )}
                </ModalBody>

                <ModalFooter>
                  <button className="btn btn-secondary" onClick={() => this.setState({ modalListado: false })}>
                    Cerrar
                  </button>
                </ModalFooter>
              </Modal>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
